module.exports = __webpack_public_path__ + "static/media/event_new_member_detail_web.d2e3b529.webp";